import { Accordion, Stack } from '@efast_public/fjd-component-library';
import React, { ReactNode } from 'react';

interface DiffDescriptionListItemProps {
  allAccordionsExpandable: boolean;
  children: ReactNode;
}

export function OdmAccordionGroup({
  allAccordionsExpandable,
  children
}: DiffDescriptionListItemProps) {
  if (allAccordionsExpandable) return <Stack spacing="m">{children}</Stack>;

  return <Accordion.Group>{children}</Accordion.Group>;
}
